import { components } from 'shared/data/walletsKyc/v1';

export const buildAccountUsageOneInitialValues = (
    accountUsage: components['schemas']['FormAccountUsageAnswer'] | undefined
) => ({
    collectionsAccount: accountUsage?.collectionsAccount?.toString(),
});
